document.documentElement.classList.remove('no-js');

const body = document.body;
const moneyFormat = document.documentElement.dataset.moneyFormat || '€{{amount}}';

function trapState(open) {
  body.classList.toggle('is-locked', open);
}

function openLayer(element) {
  if (!element) return;
  element.classList.add('is-open');
  element.setAttribute('aria-hidden', 'false');
  trapState(true);
  const focusable = element.querySelector('button, a, input, select');
  if (focusable) focusable.focus();
}

function closeLayer(element) {
  if (!element) return;
  element.classList.remove('is-open');
  element.setAttribute('aria-hidden', 'true');
  trapState(false);
}

document.addEventListener('click', (event) => {
  const menuOpen = event.target.closest('[data-menu-open]');
  const menuClose = event.target.closest('[data-menu-close]');
  const cartOpen = event.target.closest('[data-cart-open]');
  const cartClose = event.target.closest('[data-cart-close]');
  const searchOpen = event.target.closest('[data-search-open]');
  const searchClose = event.target.closest('[data-search-close]');
  const filterToggle = event.target.closest('[data-filter-toggle]');
  const quantityButton = event.target.closest('[data-quantity-action]');
  const cartRemove = event.target.closest('[data-cart-remove]');

  if (menuOpen) openLayer(document.getElementById('MobileMenu'));
  if (menuClose) closeLayer(document.getElementById('MobileMenu'));
  if (cartOpen) openLayer(document.getElementById('CartDrawer'));
  if (cartClose) closeLayer(document.getElementById('CartDrawer'));
  if (searchOpen) {
    openLayer(document.getElementById('SearchModal'));
    window.setTimeout(() => document.getElementById('PredictiveSearchInput')?.focus(), 100);
  }
  if (searchClose) closeLayer(document.getElementById('SearchModal'));
  if (filterToggle) document.querySelector('.filters')?.classList.toggle('is-open');
  if (quantityButton) {
    const input = quantityButton.parentElement.querySelector('input');
    const next = Number(input.value) + (quantityButton.dataset.quantityAction === 'increase' ? 1 : -1);
    input.value = Math.max(Number(input.min || 1), next);
  }
  if (cartRemove) updateCartLine(cartRemove.dataset.cartRemove, 0);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.is-open').forEach(closeLayer);
});

async function updateCartLine(key, quantity) {
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('Cart update failed');
    renderCart(await response.json());
  } catch (error) {
    console.error(error);
  }
}

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const variantInput = form.querySelector('[name="id"]');
  const productRoot = form.closest('[data-product-root]');
  const variantsScript = productRoot?.querySelector('[data-variants-json]');
  const addButton = form.querySelector('[name="add"]');
  const priceTarget = productRoot?.querySelector('[data-product-price]');
  let variants = [];
  try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch (_) {}

  const syncVariant = () => {
    const options = [...form.querySelectorAll('[data-option-index]')].reduce((selected, group) => {
      const checked = group.querySelector('input:checked, select');
      selected[Number(group.dataset.optionIndex)] = checked?.value;
      return selected;
    }, []);
    const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
    if (!variant) {
      addButton.disabled = true;
      addButton.textContent = 'Nicht verfügbar';
      return;
    }
    variantInput.value = variant.id;
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    if (priceTarget) priceTarget.textContent = formatMoney(variant.price);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };
  form.addEventListener('change', syncVariant);
  form.addEventListener('submit', async (event) => {
    if (!form.matches('[data-ajax-cart-form]')) return;
    event.preventDefault();
    addButton.disabled = true;
    const original = addButton.textContent;
    addButton.textContent = 'Wird hinzugefügt …';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      if (!response.ok) throw new Error((await response.json()).description || 'Produkt konnte nicht hinzugefügt werden.');
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      renderCart(await cartResponse.json());
      openLayer(document.getElementById('CartDrawer'));
      addButton.disabled = false;
      addButton.textContent = original;
    } catch (error) {
      const message = form.querySelector('[data-product-error]');
      if (message) { message.hidden = false; message.textContent = error.message; }
      addButton.disabled = false;
      addButton.textContent = original;
    }
  });
});

document.querySelectorAll('[data-media-thumbnail]').forEach((button) => {
  button.addEventListener('click', () => {
    const root = button.closest('[data-product-root]');
    root.querySelectorAll('[data-media-thumbnail]').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');
    const target = root.querySelector(`[data-media-id="${button.dataset.mediaThumbnail}"]`);
    root.querySelectorAll('[data-product-media]').forEach((item) => item.hidden = true);
    if (target) target.hidden = false;
  });
});

function formatMoney(cents) {
  return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
}

function escapeHtml(value = '') {
  return String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' })[character]);
}

function sizedImage(url, width) {
  if (!url) return '';
  return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
}

function renderCart(cart) {
  document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
  const bodyTarget = document.querySelector('[data-cart-drawer-body]');
  const footer = document.querySelector('[data-cart-drawer-footer]');
  const total = document.querySelector('[data-cart-total]');
  if (!bodyTarget || !footer) return;

  if (!cart.items.length) {
    bodyTarget.innerHTML = '<div class="empty-state"><p>Ihr Warenkorb ist noch leer.</p><a class="button button--secondary" href="/collections/all">Produkte entdecken</a></div>';
    footer.hidden = true;
    return;
  }

  bodyTarget.innerHTML = cart.items.map((item) => {
    const image = item.featured_image?.url || item.image || '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : '';
    return `<div class="cart-line" data-line-key="${escapeHtml(item.key)}">
      <a href="${escapeHtml(item.url)}">${image ? `<img src="${escapeHtml(sizedImage(image, 180))}" alt="${escapeHtml(item.product_title)}" width="85" height="85">` : ''}</a>
      <div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>${variant}<div class="cart-line__price">${formatMoney(item.final_line_price)}</div><button class="text-button" data-cart-remove="${escapeHtml(item.key)}" type="button">Entfernen</button></div>
    </div>`;
  }).join('');
  footer.hidden = false;
  if (total) total.textContent = formatMoney(cart.total_price);
}

const predictiveInput = document.getElementById('PredictiveSearchInput');
const predictiveResults = document.querySelector('[data-predictive-results]');
let predictiveTimer;

predictiveInput?.addEventListener('input', () => {
  window.clearTimeout(predictiveTimer);
  const query = predictiveInput.value.trim();
  if (query.length < 2) {
    predictiveResults.innerHTML = '<p class="muted">Geben Sie mindestens zwei Buchstaben ein.</p>';
    return;
  }
  predictiveTimer = window.setTimeout(async () => {
    try {
      predictiveResults.innerHTML = '<p class="muted">Suche läuft …</p>';
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`;
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Search failed');
      const products = (await response.json()).resources?.results?.products || [];
      if (!products.length) {
        predictiveResults.innerHTML = '<p class="muted">Keine passenden Produkte gefunden.</p>';
        return;
      }
      predictiveResults.innerHTML = `<div class="predictive-search-grid">${products.map((product) => `<a class="predictive-result" href="${escapeHtml(product.url)}">${product.featured_image?.url ? `<img src="${escapeHtml(sizedImage(product.featured_image.url, 160))}" alt="${escapeHtml(product.title)}" width="72" height="72">` : ''}<div><strong>${escapeHtml(product.title)}</strong><span>${escapeHtml(product.price)}</span></div></a>`).join('')}</div>`;
    } catch (_) {
      predictiveResults.innerHTML = '<p class="muted">Die Vorschläge sind gerade nicht verfügbar. Bitte starten Sie die Suche mit Enter.</p>';
    }
  }, 250);
});
